export function validate(value) {
  return (
    typeof value?.name === 'string' && /tx_card_field_types/.test(value.name)
  )
}
